import type { Bounds } from '../elements/bounds';

export const NODE_BOX_LINE_WIDTH = 2;
export const NODE_BOX_LINE_ALPHA = 1;
export const NODE_BOX_LINE_COLOR = 0xebebeb;
export const NODE_BOX_PADDING = 40;
export const NODE_BOX_BORDER_RADIUS = 20;
export const NODE_BOX_LABEL_MARGIN = 7;
export const NODE_BOX_LABEL_PADDING = 20;
export const NODE_BOX_LABEL_FONT = 'OpenSans-Bold';
export const NODE_BOX_LABEL_FONT_SIZE = 15;

export const defaultNodeBoxPadding: Bounds = {
  left: NODE_BOX_PADDING,
  top: NODE_BOX_PADDING,
  right: NODE_BOX_PADDING,
  bottom: NODE_BOX_PADDING,
};

interface NodeBoxPositions {
  bottom: number;
  bounds: Bounds;
  centerX: number;
  height: number;
  left: number;
  right: number;
  top: number;
  width: number;
}

export const getNodeBoxPositions = (
  entitiesBounds: Bounds,
  labelTextMetrics: { width: number; height: number },
  boxPadding: Bounds = defaultNodeBoxPadding, // customizable to dynamically resize on frontend
): NodeBoxPositions => {
  const left = entitiesBounds.left - boxPadding.left;
  const top = entitiesBounds.top - boxPadding.top;
  const width =
    entitiesBounds.right -
    entitiesBounds.left +
    boxPadding.left +
    boxPadding.right;
  const height =
    entitiesBounds.bottom -
    entitiesBounds.top +
    boxPadding.top +
    boxPadding.bottom;
  const right = left + width;
  const bottom = top + height;
  const centerX = left + width / 2;
  const bounds = {
    top: top - labelTextMetrics.height / 2,
    bottom,
    left: Math.min(
      left,
      centerX - labelTextMetrics.width / 2 - NODE_BOX_LABEL_PADDING,
    ),
    right: Math.max(
      right,
      centerX + labelTextMetrics.width / 2 + NODE_BOX_LABEL_PADDING,
    ),
  };
  return {
    bottom,
    bounds,
    centerX,
    height,
    left,
    right,
    top,
    width,
  };
};
